<template>
  <van-row class="navContainer">
    <van-col span="4" class="navLeft" @click="BTActionLeftArrow">
      <van-icon class="arrowLeftStyle" name="arrow-left" v-if="hasBack" />
    </van-col>
    <van-col span="16" class="navCenter">{{title}}</van-col>
    <van-col span="4" class="navRight" @click="BTActionRightArrow">
      <van-icon v-if="hasHome" name="wap-home-o" />
    </van-col>
  </van-row>
</template>

<script>
export default {
  name: "navigation",
  props: {
    title: {
      //导航栏标题
      type: String,
      default: "标题"
    },
    hasBack: {
      //是否显示返回按钮
      type: Boolean,
      default: true
    },
    hasHome: {
      //是否显示右侧按钮
      type: Boolean,
      default: false
    },
    rightIcon: {
      //右侧按钮icon
      type: String,
      default: ""
    }
  },
  methods: {
    BTActionRightArrow() {
      if (this.hasHome) {
        this.$emit("BTRightClick");
      }
    },
    BTActionLeftArrow() {
      if (this.hasBack) {
        this.$router.go(-1); //返回上一路由栈
      }
    }
  }
};
</script>

<style scoped>
.navContainer {
  height: 60px;
  width: 100%;
  line-height: 60px;
  border-bottom: solid lightgrey 1px;
  background-color: white;
}
.arrowLeftStyle {
  margin-left: -10px;
}

.navLeft {
  background-color: transparent;
  font-size: 20px;
  height: 100%;

  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
}
.navCenter {
  font-family: PingFangSC-Regular;
  font-size: 1.8rem;
  color: #000;
  letter-spacing: 0;
  text-align: center;
}
.navRight {
  background-color: transparent;
  height: 100%;
  font-size: 20px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue